export function initVideoReveal($) {
	$('.video-reveal-block').each(function(n, el) {
		var $display = $('.video-display', el);
		var $video = $('.video-display-media', el);

		$display.on('shown.bs.collapse', function() {
			$video[0].play();
		});

		$display.on('hidden.bs.collapse', function() {
			$video[0].pause();
		});
	});
}